import { gql, useQuery } from '@apollo/client';
import * as React from 'react';

import { EventRegistrationTable } from '@/components/EventRegistrationTable';
import { EventRsvpList } from '@/components/RsvpList/EventRsvpList';
import { ERegistrationType } from '@/graphql-types/globalTypes';

import {
  SimpleEventRegistrants_EventQuery,
  SimpleEventRegistrants_EventQueryVariables,
} from './graphql-types/SimpleEventRegistrants_EventQuery';

const EVENT = gql`
  query SimpleEventRegistrants_EventQuery($input: EventInput!) {
    event(input: $input) {
      eventV2 {
        _id
        registrationType
      }
    }
  }
`;

export const SimpleEventRegistrants: React.FC<{
  eventId: string;
}> = ({ eventId }) => {
  const queryResult = useQuery<
    SimpleEventRegistrants_EventQuery,
    SimpleEventRegistrants_EventQueryVariables
  >(EVENT, {
    variables: { input: { _id: eventId } },
  });

  const isTicketed =
    queryResult.data?.event.eventV2?.registrationType ===
    ERegistrationType.TICKET;

  if (isTicketed) {
    return <EventRegistrationTable eventId={eventId} />;
  } else {
    return <EventRsvpList eventId={eventId} />;
  }
};
